export const Config = {
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:8080/api',
  leoProManagedProfilePrice: 3,
  leoProManagedProfileMaxQty: 12,
};
